import { clearRawFieldValues } from '@ui/features/quote-builder/state/utilities/raw-field-values';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function csrCleared(state: WritableDraft<QuoteBuilderStateType>) {
  state.csrOid = null;
  state.csrName = null;
  state.csrEmail = null;

  clearRawFieldValues(state, [
    { uuid: state.uuid, field: 'csrName' },
    { uuid: state.uuid, field: 'csrEmail' },
    { uuid: state.uuid, field: 'csrPhone' },
  ]);
}
